import React, { useCallback, useEffect, useState } from "react";
import "./StandingOrderList.scss";
import { ICartListInfo } from "../../interface/ICart";

import { IBusinessInfo } from "../../interface/IBusiness";
import { convertDateToStringFormat } from "../../actions/common";
import { useTranslation } from "react-i18next";
import { setDecimalValWithCurrencyLang } from "../../actions/priceFormatter";
import { getTranslationsLang } from "../../reducers/translations";
import { useSelector } from "react-redux";

type Props = {
  carts: ICartListInfo[] | [];
  business: IBusinessInfo;
  cartDateSelector?: Date | undefined;
  onGoToCart: (cart: ICartListInfo) => void;
};

const StandingOrderList: React.FC<Props> = (props) => {
  const [cart_list, setCartList] = useState<ICartListInfo[]>([]);
  const { t, i18n } = useTranslation("common");
  const localLang = useSelector(getTranslationsLang);

  //setStatuses
  useEffect(() => {
    setCartList(props.carts);
  }, [props.carts]);

  const gotoCart = (cart: ICartListInfo) => {
    props.onGoToCart(cart);
  };

  const renderDay = (day: number) => {
    switch (day) {
      case 0:
        return <>{t("Sunday")}</>;
      case 1:
        return <>{t("Monday")}</>;
      case 2:
        return <>{t("Tuesday")}</>;
      case 3:
        return <>{t("Wednesday")}</>;
      case 4:
        return <>{t("Thursday")}</>;
      case 5:
        return <>{t("Friday")}</>;
      case 6:
        return <>{t("Saturday")}</>;
      default:
        return null;
    }
  };

  return (
    <>
      <div className="list-header">{t("StandingOrder")}</div>
      {cart_list &&
        cart_list.length > 0 &&
        cart_list.map((cart: ICartListInfo, i: number) => (
          <div
            key={
              cart.id + "_" + cart.isLateOrder + "_" + cart.soAmend + "_" + i
            }
            className="card cart-default-selection-card shadow-1"
            onClick={() => gotoCart(cart)}
          >
            <div className="flex justify-content-between ">
              <div>
                <div>{renderDay(cart.dayLocal || 0)}</div>
              </div>

              <div className="mb-2 mr-2">
                {cart.total ? (
                  <span className="list-cost">
                    {setDecimalValWithCurrencyLang(
                      cart.total,
                      localLang,
                      props.business,
                      false
                    )}
                  </span>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default StandingOrderList;
